import { render, staticRenderFns } from "./default.html?vue&type=template&id=39336072&external"
import script from "./default.ts?vue&type=script&lang=ts&external"
export * from "./default.ts?vue&type=script&lang=ts&external"
import style0 from "./default.vue?vue&type=style&index=0&id=39336072&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/5/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39336072')) {
      api.createRecord('39336072', component.options)
    } else {
      api.reload('39336072', component.options)
    }
    module.hot.accept("./default.html?vue&type=template&id=39336072&external", function () {
      api.rerender('39336072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/default.vue"
export default component.exports